import styled from 'styled-components';

export const HeaderWrapper = styled.div<{ titleWithLine?: boolean }>`
  margin-bottom: 8px;
  display: flex;
  align-items: ${({ titleWithLine }) => (titleWithLine ? 'center' : 'flex-start')};
  flex-direction: ${({ titleWithLine }) => !titleWithLine && 'column-reverse'};
`;

export const Header = styled.span<{ titleWithLine?: boolean }>`
  font-family: 'Poppins', sans-serif;
  display: block;
  text-transform: uppercase;
  font-size: ${({ titleWithLine }) => (titleWithLine ? '12px' : '18px')};
  font-weight: 700;
  letter-spacing: 1.3px;
  line-height: 150%;
  flex-shrink: 0;
  padding-right: 8px;
  margin-top: ${({ titleWithLine }) => !titleWithLine && '8px'};
`;

export const Line = styled.div`
  width: 100%;
  height: 2px;
  background: black;
`;
